<template>
  <div class="news">
      <div class="news-banner"></div>
    <div class="news-section">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>行业动态</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div v-show="newstype === 1" class="item-list" v-for="(item,index) in newsList1" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>

            <p class="item-list-title">{{item.Title}}</p>
            <p class="item-list-content">{{item.Content}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.Id }}"
              >
                <img src="../assets/img/sanjiao.png" />

                <span>MORE</span>
              </router-link>
            </div>
          </div>

          <div v-show="newstype === 2" class="item-list" v-for="(item,index) in newsList2" :key="'info2-' + index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>

            <p class="item-list-title">{{item.Title}}</p>
            <p class="item-list-content">{{item.Content}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.Id }}"
              >
                <img src="../assets/img/sanjiao.png" />

                <span>MORE</span>
              </router-link>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      loading: true,
      newsList1: 
      [
        {
          "Id": 11,
          "Title": "湖北中恒善能电力技术有限公司正式成立",
          "Img": require("../../public/zh1-1.jpg"),
          "Type": 1,
          "Content": "      热烈祝贺湖北中恒善能电力技术有限公司成立，作为电力行业具备自主创新的企业，中恒善能提供以数字化智能终端为基础，结合无线物联网、大数据、人工智能等技术，助力能源互联网的实现，推动电力生产及运营更高效、更安全。公司围绕新能源及人工智能快速发展的机遇，坚持以电力行业需求为导向，以技术革新为核心发展战略，主要推进人工智能技术加快数字化智能终端在电力数字化方面的应用，并结合电力需求进行无线供能技术、无线传感技术及空间无线监测技术在电力物联网领域的应用设备研发及推广。 公司具有多层次多专业的科研专家团队，研发了具有行业先进水平的无线传感及监测、数字化智能终端等系列产品，革新了一些传统运维和监督模式，加快电力行业在电力物联网背景下智能高效运维和智慧安全监督的转型升级。 目前公司已经形成了博士为技术核心，大部分研发人员达到本科及以上的水平，构成了决策和执行梯度结合的水平。公司的主要产品包括：基于大数据分析的综合能源服务系统、新能源电力控制系统（配合电力国产化进展）、无线物联网系列产品、数字化智能终端系列产品。",
          "CreateTime": "2014/04/01 19:46:46"
        },
        {
          "Id": 12,
          "Title": "热烈祝贺中恒善能获得智慧配电运维管理系统软件著作权",
          "Img": require("../../public/honor4.png"),
          "Type": 1,
          "Content": "历时几个月的软件开发，热烈祝贺湖北中恒善能电力技术有限公司获得智慧配电运维管理系统软件著作权!",
          "CreateTime": "2022/02/17 16:24:11"
        },
        {
          "Id": 13,
          "Title": "中恒善能聚力标准研制 赋能低碳转型",
          "Img": require("../../public/seminar.png"),
          "Type": 1,
          "Content": "6 月 1 日，由全国燃烧节能净化标准化技术委员会（SAC/TC441）归口管理、广东佛山仙湖实验室牵头编制的两项国家标准化指导性技术文件项目启动会，在安徽合肥顺利召开。我司作为参与单位出席本次会议，同中国科学技术大学、浙江大学、安徽省市场监督管理局等多家单位的行业专家齐聚一堂，共同对《工业炉窑氨燃料燃烧装置通用技术规范》《工业氨燃烧烟气残氨激光检测方法》两项标准文稿开展评审、研讨与交流。",
          "CreateTime": "2026/06/02 10:00:00"
        },
      ],
      newsList2: 
      [
        {
          "Id": 3,
          "Title": "红创“碳”讯第37期",
          "Img": require("../../public/02.jpg"),
          "Type": 1,
          "Content": " 政策导读 ○国务院：引导县城分布式能源发展 推进屋顶分布式光伏发电。○国家发改委、国家能源局：推进新能源领域增量混改 打造新能源标杆项目。○发改委：完善煤炭市场价格形成机制正式施行 明确煤炭领域经营者哄抬价格行为科技前沿。",
          "CreateTime": "2022/05/08 07:28"
        },
        // {
        //   "Id": 1,
        //   "Title": "红创“碳”讯",
        //   "Img": require("../../public/01.jpg"),
        //   "Type": 1,
        //   "Content": " 【重磅】1.中国将组建全国统一的能源市场，如何统一？2.国务院安全生产委员会印发《“十四五”国家安全生产规划》3.国家发改委：支持智慧能源发展，超前布局能源等基础设施建设。",
        //   "CreateTime": "2022/04/18 07:28"
        // },
        {
          "Id": 2,
          "Title": "国务院发布《新时代的中国能源发展》白皮书：加强能源输配网络建设",
          "Img": require("../../public/hy2-1.jpg"),
          "Type": 1,
          "Content": "12月21日15时，中国国务院新闻办公室召开新闻发布会发布《新时代的中国能源发展》白皮书。白皮书显示，加速发展绿氢制取、储运和应用等氢能产业链技术装备，促进氢能燃料电池技术链、氢燃料电池汽车产业链发展。支持能源各环节各场景储能应用，着力推进储能与可再生能源互补发展。支持新能源微电网建设，形成发储用一体化局域清洁供能系统。",
          "CreateTime": "2020/12/21 15:48:36"
        }
      ],
      newstype: 1
    };
  },
  methods: {
    // loadData() {
    //   this.loading = true;
    //   this.$http
    //     .get(`News?type=${this.newstype}&num=6`)
    //     .then(response => {
    //       //console.log(response);
    //       this.newsList = response.data;
    //       this.loading = false;
    //       //window.console.log(this.newsList);
    //     })
    //     .catch(function(error) {
    //       window.console.log(error);
    //     });
    // }
  },
  mounted() {
    // this.loadData();
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      // this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .news-banner {
      width: 100%;
      height: 405px;
      background: url(../assets/img/bgtop_news.jpg) center;
  }

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1240px;
        margin: 0 auto 40px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 350px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;
          padding: 20px;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 310px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
            font-family: \\5FAE\8F6F\96C5\9ED1;
            font-weight: bold;
          }

          &-content {
            width: 273px;
            height: 90px;
            font-size: 14px;
            color: gray;
            text-indent:2em;  //首行缩进

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;

            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 5;
            // -webkit-box-orient: vertical;
            // white-space: normal !important;
            // word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>